var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auction-dialog', {
    attrs: {
      "title": "예상 배송비 안내"
    },
    on: {
      "open": _vm.init
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function fn() {
        return [_c('p', {
          staticClass: "font-size-14 font-size-md-16"
        }, [_vm._v(" 기본 배송지 기준"), _c('strong', {
          staticClass: "font-size-16 font-size-md-20 pl-8"
        }, [_vm._v(_vm._s(_vm.delivery) + "원")])]), _c('div', {
          staticClass: "mt-6 mt-md-10"
        }, [_c('v-card', {
          staticClass: "grey-ef",
          attrs: {
            "tile": "",
            "elevation": "0"
          }
        }, [_c('v-card-text', {
          staticClass: "pa-16 pa-md-24"
        }, [_c('p', {
          staticClass: "font-size-14 grey-68--text"
        }, [_vm._v(" 온라인 경매의 낙찰작은 직접 픽업이 원칙입니다."), _c('br'), _vm._v(" 만약, 픽업이 불가능한 경우 배송을 요청할 수 있으며, 아래와 같이 배송비가 부과됩니다. ")])])], 1)], 1), _c('div', {
          staticClass: "mt-14 mt-md-20"
        }, [_c('v-data-table', {
          staticClass: "v-data-table--default v-data-table--none-active-bg",
          attrs: {
            "headers": _vm.headers,
            "items": _vm.items,
            "hide-default-footer": "",
            "disable-sort": "",
            "items-per-page": -1
          },
          scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
            return header.hasOwnProperty('formatter');
          }), function (header) {
            return {
              key: "item.".concat(header.value),
              fn: function fn(_ref2) {
                var value = _ref2.value;
                return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
              }
            };
          }), {
            key: "item.domestic",
            fn: function fn(_ref3) {
              var value = _ref3.value;
              return [_c('div', {
                staticClass: "ma-md-n4",
                staticStyle: {
                  "margin-bottom": "-5px!important"
                }
              }, _vm._l(value, function (_ref4) {
                var region = _ref4.region,
                    amount = _ref4.amount;
                return _c('v-row', {
                  key: region,
                  attrs: {
                    "no-gutters": "",
                    "justify": "end",
                    "justify-sm": "center"
                  }
                }, [_c('v-col', {
                  staticClass: "border-md-bottom",
                  attrs: {
                    "cols": "auto",
                    "md": "4"
                  }
                }, [_c('span', {
                  staticClass: "d-none d-md-flex align-center justify-center h-md-60px font-weight-medium grey-ef"
                }, [_vm._v(_vm._s(region))]), _c('span', {
                  staticClass: "d-md-none font-weight-medium pr-10"
                }, [_vm._v(_vm._s(region))])]), _c('v-col', {
                  staticClass: "border-md-bottom",
                  attrs: {
                    "cols": "auto",
                    "md": "8"
                  }
                }, [_c('div', {
                  staticClass: "d-flex align-center justify-center h-md-60px"
                }, [_vm._v(_vm._s(amount.format()) + "원")])])], 1);
              }), 1)];
            }
          }, {
            key: "item.overseas",
            fn: function fn(_ref5) {
              var value = _ref5.value;
              return [_c('span', [_vm._v(" " + _vm._s(value) + " ")])];
            }
          }], null, true)
        })], 1), _c('div', {
          staticClass: "mt-12"
        }, [_c('p', {
          staticClass: "font-size-14 grey-68--text"
        }, [_vm._v(" 동일 경매에서 1점 초과 낙찰시, 초과분부터 1만원씩 추가 (단, 동일장소/일시인 경우에 한함)"), _c('br'), _vm._v(" 예) 서울 지역 3점 낙찰 : 5만원+1만원+1만원 = 7만원 ")])])];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }